import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '@store/types';
import { addOrUpdateImageDocument, setNotSubmittedDeletedImage } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { setMachineImage } from '@reducers/machines';
import type { Machine } from '@reducers/machines/types';
import { KEYS_TAGS } from '@components/imageHandling/common';
import { Alert } from '@helpers';
import { restoreSoftDeletedMessagesByKey } from '@reducers/v2/messagesBus/messagesBus.slice';

interface RestoreRemoveImageDocumentPayload {
  documentId: number;
  errorMessage: string | null;
}

export const restoreRemoveImageDocument = createAsyncThunk<void, RestoreRemoveImageDocumentPayload, { dispatch: AppDispatch }>(
  'imageHandlingV2/restoreRemoveImageDocument',
  async ({ documentId, errorMessage }, { getState, dispatch }) => {
    //reverting logic
    const rootState = getState() as RootState;
    const deletedImageData = rootState.imageHandlingV2.notSubmittedDeletedImage;
    if (deletedImageData && deletedImageData?.document?.documentId === documentId) {
      dispatch(
        addOrUpdateImageDocument({
          document: deletedImageData.document,
          imageContext: deletedImageData.imageContext,
        })
      );

      const { imageContext, document } = deletedImageData;
      if ('scopeId' in imageContext && imageContext.scopeId === KEYS_TAGS.Machine && typeof imageContext.scopeReferenceId === 'number') {
        dispatch(
          setMachineImage({
            machineId: imageContext.scopeReferenceId,
            machineImage: document as NonNullable<Machine['machineImage']>,
          })
        );
      }

      dispatch(setNotSubmittedDeletedImage(null));
      dispatch(restoreSoftDeletedMessagesByKey(documentId));
      Alert({ title: 'Error', text: errorMessage || 'Error during image deletion. Please try again.' });
    }
  }
);
